import { getSearchParameterByName } from '@omnia/ui'
import { getShowtimeById } from '@vista-digital/occ-domain'
import { ticketingWorkflow } from '@/content/services/workflows/ticketing/ticketing-workflow'

export const getSiteIdInTicketingWorkflow = (): string => {
    const showtimeIdFromQuery = getSearchParameterByName('showtimeId')
    if (showtimeIdFromQuery) {
        return getShowtimeById(showtimeIdFromQuery)?.siteId || ''
    }
    return ticketingWorkflow.State.siteId || ''
}

export default getSiteIdInTicketingWorkflow
